module.exports = __webpack_public_path__ + "static/bus_interprovincial-29d7e9386089fc7fdc6e80cdf98de63a.jpg";